import React from 'react';

export const TableLayout = ({ header, body, footer }) => (
  <div className="table-responsive">
    <table className="table table-hover">
      {header}
      {body}
      {footer}
    </table>
  </div>
);
